import { useRef, useState } from 'react';
import { getTopPlacePrediction } from '../../../common/search';

// Selects Google's top prediction for typed text. A newer lookup, or a
// suggestion tapped meanwhile, takes over from one still running.
export function usePlaceLookup(selectPlace) {
  const lookupRef = useRef(0);
  const [findingPlace, setFindingPlace] = useState(false);

  const cancelPlaceLookup = () => {
    lookupRef.current += 1;
    setFindingPlace(false);
  };

  // Resolves to 'selected', 'notFound' (the prediction couldn't be
  // geocoded), 'noMatch', 'unavailable' (Google failed) or 'superseded'.
  const lookUpTypedPlace = async (text) => {
    lookupRef.current += 1;
    const lookupId = lookupRef.current;
    const isLatestLookup = () => lookupRef.current === lookupId;
    setFindingPlace(true);
    const outcome = await getTopPlacePrediction(text).then(
      async (prediction) => {
        if (!prediction) {
          return 'noMatch';
        }
        if (!isLatestLookup()) {
          return 'superseded';
        }
        return (await selectPlace(prediction.description))
          ? 'selected'
          : 'notFound';
      },
      () => 'unavailable'
    );
    if (!isLatestLookup()) {
      return 'superseded';
    }
    setFindingPlace(false);
    return outcome;
  };

  return { findingPlace, lookUpTypedPlace, cancelPlaceLookup };
}
